/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';


import {getLinkForSignIn, UserContext} from "../UserContext";
// import Wave from '../assets/svg/components/wave-1-bottom-sm.svg'
import PromoIcon from "../assets/svg/icons/icon-white-6.svg";

import {linkForIsp} from "./LinkHelper";
import DropChart from "./outage/DropChart";
import ScoreIndicator from "../components/ScoreIndicator";
import OutageSeverityIndicator from "./isp/OutageSeverityIndicator";
import IspRankSummary from "./isp/IspRankSummary";

export default class HomePreferredIsp extends Component {

    static contextType = UserContext;

    // --------------------------------------------------------------------------------
    // MAIN RENDERING
    // --------------------------------------------------------------------------------

    /*renderWave() {
        return (
            <div id="SVG_HomePreferredIsp" className="svg-preloader position-relative bg-light overflow-hidden">
                <div className="container space-3">
                    <div className="card-deck card-lg-gutters-2 d-block d-lg-flex">

                        {this.renderCurrentIspCard()}
                        {this.renderSignInPromoCard()}

                    </div>
                </div>

                <figure className="position-absolute right-0 bottom-0 left-0">
                    <img className="img-fluid" src={Wave}
                         alt="Wave"
                         data-parent="#SVG_HomePreferredIsp"/>
                </figure>
            </div>
        );
    }*/

    render() {
        const session = this.props.session;

        return (
            <div className="position-relative">
                <div className="bg-img-hero main-hero space-2 gradient-x-overlay-lg-dark">
                    <div className="text-center space-top-lg-2">
                        <div className="w-lg-80 mx-auto">
                            <h1 className="display-4 font-size-md-down-5 text-white mb-3">{intl.getHTML('promo_5_title')}</h1>
                        </div>
                        <div className="w-md-80 w-lg-60 mx-auto">
                            <p className="lead text-white">{intl.get('promo_5_subtitle')}</p>
                        </div>
                    </div>
                </div>
                <div className="position-relative overflow-hidden">
                    <div className="container space-top-2 space-bottom-2">
                        <div className="card-deck card-lg-gutters-2 d-block d-lg-flex">

                            {this.renderCurrentIspCard(session)}
                            {this.renderAccountIspCard(session)}

                        </div>
                    </div>
                    {/* <figure className="position-absolute right-0 bottom-0 left-0">
                        <img className="img-fluid" src={Wave}
                             alt="Wave"
                             data-parent="#SVG_HomePreferredIsp"/>
                    </figure> */}
                </div>
            </div>
        );
    }


    renderScore(isp) {
        const scoreValue = isp.ispScore.scoreValue;

        return (
            <div className="mb-2 mr-4">
                <ScoreIndicator score={scoreValue}/>
                <div>
                    <IspRankSummary isp={isp} score={scoreValue}/>
                </div>
            </div>
        )
    }

    renderOutageScore(isp) {
        let scoreValue = 0.0;
        let outageText = intl.get('isp_outage_weekly_summary_ok');
        if (isp.twoCount > 0) {
            scoreValue = isp.twoMaxSeverityNum * 20.0;
            outageText = intl.get('isp_outage_weekly_summary_value', {count: isp.twoCount});
        }

        return (
            <div className="mb-2">
                <OutageSeverityIndicator score={scoreValue} />
                <div>
                    <small className="text-muted">{outageText}</small>
                </div>
            </div>
        )
    }

    renderCurrentIspCard(session) {
        if (session.currentIsp) {
            return this.renderIspCard(session.currentIsp, session.userAtHome);
        } else {
            return '';
        }
    }

    renderAccountIspCard(session) {
        if (session.currentIspDropPoints) {
            const isp = session.currentIsp;
            return this.renderDropChart(isp.name, isp.countryRegion ? isp.countryRegion : isp.countryName, session.currentIspDropPoints);
        } else if (session.accountIsp) {
            return this.renderIspCard(session.accountIsp, true);
        } else {
            return this.renderSignInPromoCard();
        }
    }

    renderDropChart(ispName, ispWhere, points) {
        return (
            <div className="card card-bordered shadow mb-3 mb-lg-0">
                <div className="card-body p-5">
                    <div className="media">
                        <div className="ml-2 media-body">
                             <span className="small text-muted text-center">{intl.getHTML('drop_rate_this_week', {isp:ispName, place:ispWhere})}</span>
                        </div>
                    </div>
                    <div className="media">
                        <div className="media-body p-1">
                            <DropChart points={points}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderHomeOrRoamingTag(isHome) {
        if (isHome) {
            return (
                <div>
                    <span className="small">{intl.get('isp_home')} </span>
                    <small className="fas fa-home"/>
                </div>
            )
        } else {
            return (
                <div>
                    <span className="small">{intl.get('isp_current')} </span>
                    <small className="fas fa-globe"/>
                </div>
            )
        }
    }

    renderIspAction(isp, isHome) {
        const hasAccount = this.props.session.accountUser;
        const isAtHome = this.props.session.userAtHome;
        if (!hasAccount) {
            return (<div><a className="btn btn-sm btn-block btn-soft-success transition-3d-hover"
                            href={getLinkForSignIn(this.context, window.location.href)}>{intl.get('isp_promo_no_account')}</a></div>);
        } else if (isAtHome) {
            return (
                <div className="text-center">
                    <Link className="font-size-1"
                          to={linkForIsp(isp)}>{intl.get('isp_promo_at_home')}</Link></div>);
        } else if (isHome) {
            return (
                <div className="text-center">
                    <Link className="font-size-1" to={linkForIsp(isp)}>{intl.get('isp_promo_is_home')}</Link>
                </div>);
        } else {
            let location = isp.countryCity ? isp.countryCity : isp.countryRegion ? isp.countryRegion : isp.countryName;
            let ispActionText = intl.get('isp_set_as_home', {ispName: isp.name, ispLocation: location});
            return (
                <div className="text-center">
                    <a className="font-size-1" href="/#" onClick={(e) => {
                        e.preventDefault();
                        this.confirmAndChangeHomeGeoIsp();
                    }}>
                        {ispActionText}
                    </a>
                </div>
            );
        }
    }

    confirmAndChangeHomeGeoIsp() {

        const isp = this.props.session.currentIsp;
        let location = isp.countryCity ? isp.countryCity : isp.countryRegion ? isp.countryRegion : isp.countryName;
        let ispActionText = intl.get('isp_set_as_home_provider', {ispName: isp.name, ispLocation: location});

        if (window.confirm(ispActionText)) {

            fetch('/rest/users/updateusergeoisp')
                .then(response => {
                    //this.forceUpdate();
                    window.location.reload();
                    //location.reload(true);
                })
                .catch(error => {
                });
        }
    }

    renderIspCard(isp, isHome) {
        let ispLink = linkForIsp(isp);

        return (
            <div className="card card-bordered shadow mb-3 mb-lg-0">
                <div className="card-body p-5">
                    <div className="d-flex justify-content-between mb-3">
                        <div className="flex-column">
                            <div className="media">
                                <figure className="ie-height-56 w-100 max-w-8rem mb-4 mr-4">
                                    <Link to={ispLink}><img className="img-fluid rounded-square" src={isp.logoImageUrl}
                                                            width="96" height="96" alt={isp.name + ' logo'}/></Link>
                                </figure>
                                <div className="media-body">
                                    <Link to={ispLink}><h3 className="h4">{isp.name}</h3></Link>
                                    <div className="d-flex">
                                        {this.renderScore(isp)}
                                        {this.renderOutageScore(isp)}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="flex-column">
                            {this.renderHomeOrRoamingTag(isHome)}
                        </div>
                    </div>
                    <div>{this.renderIspAction(isp, isHome)}</div>
                </div>

            </div>
        )
    }

    renderSignInPromoCard() {
        return (
            <div className="card bg-primary text-white shadow-primary mb-3 mb-lg-0">
                <div className="card-body p-5">
                    <div className="media">
                        <figure className="ie-height-56 w-100 max-w-8rem mb-4 mr-4">
                            <img className="img-fluid" src={PromoIcon} alt="SVG"
                                 data-parent="#SVGkeyFeatures"/>
                        </figure>
                        <div className="media-body">
                            <h3 className="h4">{intl.get('isp_promo_home_title')}</h3>
                            <p className="text-white font-size-1">{intl.get('isp_promo_home_subtitle')}</p>
                            <a className="text-white font-size-1"
                               href={getLinkForSignIn(this.context, window.location.href)}>{intl.get('isp_promo_home_action')} <span
                                className="fas fa-angle-right align-middle ml-2"/></a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderNoCurrentIspCard() {
        return (
            <div className="card bg-success text-white shadow-primary mb-3 mb-lg-0">
                <div className="card-body p-5">
                    <div className="media">
                        <figure className="ie-height-56 w-100 max-w-8rem mb-4 mr-4">
                            <img className="img-fluid" src={PromoIcon} alt="SVG"
                                 data-parent="#SVGkeyFeatures"/>
                        </figure>
                        <div className="media-body">
                            <h3 className="h4">{intl.get('isp_promo_current_title')}</h3>
                            <p className="text-white-70 font-size-1">{intl.get('isp_promo_current_subtitle')}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}